/* jslint esversion: 6 */
/**
 * Swipebox
 *
 * @author
 */
const $ = window.jQuery;
const s = {};

function init() {

	/** Add lightbox class only to gallery images */
	$('.gallery a[href$=".jpg"], .gallery a[href$=".png"], .gallery a[href$=".gif"], .gallery a[href*="placehold.it"]')
		.addClass('js-lightbox');

	/** Add gallery-specific attributes */
	$('.gallery').each(function() {
		const $element = $(this);
		const id = $element.attr('id');

		$element.find('.gallery-item').each(function() {
			const caption = $(this).find('.wp-caption-text').text().trim();

			$(this).find('a')
				.attr('title', caption)
				.attr('rel', id);
		});
	});

	/** Initialize Swipebox */
	$('.gallery').find('.js-lightbox').swipebox({
			// useCSS                  : true,          // false will force the use of jQuery for animations
			// useSVG                  : true,          // false to force the use of png for buttons
			// initialIndexOnArray     : 0,             // which image index to init when a array is passed
			// hideCloseButtonOnMobile : false,         // true will hide the close button on mobile devices
			// removeBarsOnMobile      : true,          // false will show top bar on mobile devices
			// hideBarsDelay           : 3000,          // delay before hiding bars on desktop
			// videoMaxWidth           : 1140,          // videos max width
			// beforeOpen              : function() {}, // called before opening
			// afterOpen               : null,          // called after opening
			// afterClose              : function() {}, // called after closing
			// loopAtEnd               : false          // default false, true will return to the first image after the last image is reached
		}
	);
}

export {init as default};
